<template>
  <div class="molecule-equipment-list_container">
    <molecule-filter-tag
      :tagsList="tagsList"
      @messageFilter="filterMessage"
      @selectTagList="filterTag"
      class="filter-tag--padding"
    ></molecule-filter-tag>
    <molecule-select-equipment
      :listData="filteredEquipmentList"
      @checkedListData="checkedListData"
      @selectedEquipment="selectedEquipment"
    ></molecule-select-equipment>
  </div>
</template>

<script>
import MoleculeFilterTag from "@/components/molecules/MoleculeFilterTag.vue"
import MoleculeSelectEquipment from "./MoleculeSelectEquipment"
export default {
  name: "MoleculeServerEquipmentList",
  components: {
    MoleculeFilterTag,
    MoleculeSelectEquipment,
  },
  props: {
    equipmentList: {
      type: Array,
      required: true,
    },
    tagsList: {
      type: Array,
      required: true,
    },
  },
  emits: ["checkedListData", "selectedEquipment"],
  data() {
    return {
      filteredMessageEquipmentList: [],
      filteredTagEquipmentList: [],
      filteredEquipmentList: [],
      bufferMessageFilter: "",
      bufferTagList: [],
    }
  },
  watch: {
    equipmentList: {
      deep: true,
      handler() {
        this.baseFilterEquipment()
      },
    },
    bufferMessageFilter() {
      this.baseFilterEquipment()
    },
    bufferTagList() {
      this.baseFilterEquipment()
    },
  },
  mounted() {
    this.filteredEquipmentList = this.equipmentList
  },
  methods: {
    baseFilterEquipment() {
      if (this.bufferMessageFilter === "" && this.bufferTagList.length === 0) {
        this.filteredEquipmentList = this.equipmentList
      } else {
        this.filterEquipment()
      }
    },
    filterEquipment() {
      if (this.bufferMessageFilter === "") {
        this.filteredEquipmentList = this.filteredTagEquipmentList
      } else if (this.bufferTagList.length === 0) {
        this.filteredEquipmentList = this.filteredMessageEquipmentList
      } else {
        this.filteredEquipmentList = this.filteredMessageEquipmentList.filter(
          (value) => this.filteredTagEquipmentList.includes(value)
        )
      }
    },
    filterMessage(messageFilter) {
      this.bufferMessageFilter = messageFilter
      this.filteredMessageEquipmentList = []
      for (var i = 0; i < this.equipmentList.length; i++) {
        if (this.checkSubString(this.equipmentList[i], messageFilter)) {
          this.filteredMessageEquipmentList.push(this.equipmentList[i])
        }
      }
    },
    filterTag(tagsList) {
      this.bufferTagList = tagsList
      this.filteredTagEquipmentList = []
      for (var i = 0; i < this.equipmentList.length; i++) {
        if (this.checkTagList(this.equipmentList[i], tagsList)) {
          this.filteredTagEquipmentList.push(this.equipmentList[i])
        }
      }
    },
    checkSubString(list, subString) {
      return (
        list.name.includes(subString) ||
        list.name.toLowerCase().includes(subString.toLowerCase()) ||
        list.name.toUpperCase().includes(subString.toUpperCase())
      )
    },
    checkTagList(list, tagsList) {
      let haveTag = true

      tagsList.forEach((tag) => {
        if (!list.tag.find((equipment) => equipment === tag)) haveTag = false
      })

      return haveTag

      /* Nicky Code
      var haveTag = false
      for (var i = 0; i < list.tag.length; i++) {
        for (var j = 0; j < tagsList.length; j++) {
          haveTag = haveTag || list.tag[i] === tagsList[j]
        }
      }
      return haveTag
      */
    },
    checkedListData(checkedListData) {
      this.$emit("checkedEquipmentList", checkedListData)
    },
    selectedEquipment(selectedEquipment) {
      this.$emit("selectedEquipment", selectedEquipment)
    },
  },
}
</script>

<style lang="scss" scoped>
.filter-tag--padding {
  padding-left: 15px;
  padding-right: 15px;
}
</style>
